<template>
    <div class="contentShow">
      <img v-if="caozuoType == 'img'"
            style="width:100%;height:100%;"
            id="changeImg1"
            :src="caozuoSrc"
            alt="">
      <video v-else-if="caozuoType == 'video'"
              :src="caozuoSrc"
              controls
              @click.stop=""
              webkit-playsinline="true"
              playsinline="true"
              style="max-width:100%;height:100%;"></video>
      <iframe v-else-if="caozuoType == 'file'"
              :src="caozuoSrc"
              frameborder="0"
              width="100%"
              height="100%"></iframe>
      <img v-else
            :src="require('../../assets/image/images/documentShow.png')"
            style="width:100%;height:100%;"
            alt="">
    </div>
</template>
<script>
import Bus from '../../bus.js'
export default {
  name:'contentShow',
  components:{
    Bus
  },
  props:{
    type:Object
  },
  data(){
    return{
    }
  },
  computed:{
    caozuoType(){
      return this.type.type;
    },
    caozuoSrc(){
      return this.type.link;
    }
  },
  mounted(){
  }
}
</script>
<style scoped>
  .contentShow{
    width:100%;
    height:100%;
    text-align:center;
    background-color:#ededed;
  }
  .contentShow img{
    object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/contentShow.vue